/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-magic-numbers */
import { useRive } from '@rive-app/react-canvas';
import { ClassValue } from 'clsx';
import { ReactElement, ReactNode, useEffect, useState } from 'react';

import { cn } from '@/utils';

type NotificationType = 'Positive' | 'Negative';

type StageProperties = {
  header: string;
  message: string | ReactNode;
  className?: ClassValue;
  notificationIcon?: string;
  headerStyle?: ClassValue;
  isProfileAnimation?: boolean;
  type?: NotificationType;
};

function NotificationRiveBird({ type }: { type: NotificationType }): ReactElement {
  const { RiveComponent } = useRive({
    src:
      type === 'Negative'
        ? './rivs/notification(negative).riv'
        : './rivs/notification(positive).riv',
    autoplay: true,
  });

  return (
    <div className="animate-bird-slide-in-then-out absolute -bottom-2 right-0 z-10 h-[180px] w-[165px]">
      <RiveComponent className="h-full w-full" />
    </div>
  );
}

function NotificationPopUp({
  header,
  message,
  className,
  notificationIcon,
  headerStyle,
  isProfileAnimation = false,
  type = 'Positive',
}: StageProperties): ReactElement | null {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(false), 3900);
    return () => clearTimeout(timer);
  }, []);

  // eslint-disable-next-line unicorn/no-null
  if (!isVisible) return null;

  return (
    <>
      <div
        className={cn(
          'relative',
          'absolute bottom-8 right-16 flex max-h-fit min-h-[100px] max-w-[280px] items-center justify-center gap-2 rounded-2xl bg-white shadow-custom-2',
          className,
          isProfileAnimation ? 'animate-slide-in-profile-then-out' : 'animate-slide-in-then-out',
        )}
      >
        <div className="font-Poppins flex flex-col items-start justify-center py-4 pl-6 pr-4 text-primary-blue-3">
          <p className={cn('w-[86%] text-[1.125em] font-bold', headerStyle)}>{header}</p>
          <p className="w-[86%] text-s2 font-medium leading-6">{message}</p>
        </div>
      </div>
      {notificationIcon ? (
        <img
          src={notificationIcon}
          alt="bird"
          className="animate-bird-slide-in-then-out absolute bottom-0 right-0 z-10 flex-shrink-0"
        />
      ) : (
        <NotificationRiveBird type={type} />
      )}
    </>
  );
}

export default NotificationPopUp;
